import * as Yup from 'yup'

import { THIRD_PARTY_TAG, VAST_TAG_URL } from '../../../fields'

export const getInitialValues = ad => {
  return {
    ...(ad[THIRD_PARTY_TAG] && { [THIRD_PARTY_TAG]: ad[THIRD_PARTY_TAG] }),
    ...(ad[VAST_TAG_URL] && { [VAST_TAG_URL]: ad[VAST_TAG_URL] })
  }
}

export const getValidationSchema = ad => {
  return Yup.object({
    ...(ad[THIRD_PARTY_TAG] && { [THIRD_PARTY_TAG]: Yup.string().required('Required') }),
    ...(ad[VAST_TAG_URL] && { [VAST_TAG_URL]: Yup.string().required('Required') })
  })
}
